"use strict";

module.exports = [
  {
    value: "narus",
    label: "Narus Health"
  },
  {
    value: "lucent",
    label: "Lucent Health"
  }
];
